import React, {Component} from 'react';
import {withRouter} from 'react-router';
import queryString from 'query-string';

import Registry from 'registry';
import MemberSearchForm from 'components/common/MemberSearchForm';

import {t, dt} from 'l10n';

import 'sass/headers/header.scss';

class HeaderWishlist extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileFullText: false
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(formData) {
        let {history, match} = this.props;

        history.push({
            pathname: match.url,
            search: queryString.stringify(formData)
        });
    }

    render() {
        let BOBSTORE_URL = Registry.get('BOBSTORE_URL');

        let {search} = this.props;

        let {mobileFullText} = this.state;

        return (
            <header className="profiles wishlist">
                <div className="content">
                    <h1>{t('Wishlists of members')}</h1>
                    <div className="text-subtitle mobile-hide">
                        <p dangerouslySetInnerHTML={{__html: t(
                            'Check wishlists and give real gifts to BobTV members.<br/>The real gifts are for sale on %1 the online shop of Bob. Gifts you offer are shipped via Colissimo in 24 hours.<br/>Only Bob can see the delivery address of members that created a wishlist on Bobstore.<br/>To please a BobTV member offering him a gift, just add an article (or more) from the wishlist to your basket and confirm your purchase.<br/>Do not hesitate, give a gift by clicking on the link "Give as a gift".<br/>Bob will do the rest and your gift will be delivered as soon as possible.',
                            <a href={BOBSTORE_URL} target="_blank">Bobstore</a>
                        )}}/>
                    </div>

                    <div className="text-subtitle mobile-show">
                        {mobileFullText ?
                            <span dangerouslySetInnerHTML={{
                                __html: t(
                                    'Check wishlists and give real gifts to BobTV members.<br/>The real gifts are for sale on %1 the online shop of Bob. Gifts you offer are shipped via Colissimo in 24 hours.<br/>Only Bob can see the delivery address of members that created a wishlist on Bobstore.<br/>To please a BobTV member offering him a gift, just add an article (or more) from the wishlist to your basket and confirm your purchase.<br/>Do not hesitate, give a gift by clicking on the link "Give as a gift".<br/>Bob will do the rest and your gift will be delivered as soon as possible.',
                                    <a href={BOBSTORE_URL} target="_blank">Bobstore</a>
                                )
                            }}/>
                            :
                            <span dangerouslySetInnerHTML={{
                                __html: t(
                                    'Check wishlists and give real gifts to BobTV members.<br/>The real gifts are for sale on %1 the online shop of Bob. Gifts you offer are shipped via Colissimo in 24 hours...',
                                    <a href={BOBSTORE_URL} target="_blank">Bobstore</a>
                                )
                            }}/>
                        }
                        {
                            <a className="toggle" onClick={() => this.setState({mobileFullText: !mobileFullText})}>
                                {mobileFullText ? t('Hide more') : t('Show more')}
                            </a>
                        }
                    </div>

                    <MemberSearchForm onSubmit={this.onFormSubmit} values={search}/>
                </div>
            </header>
        )
    }
}

export default withRouter(HeaderWishlist);




// WEBPACK FOOTER //
// ./src/components/wishlist/HeaderWishlist.js